import EuroIcon from '../public/static/icons/payments/euro.svg';
import PoundIcon from '../public/static/icons/payments/pound.svg';
import DollarIcon from '../public/static/icons/payments/dollar.svg';
import { DEFAULT_CURRENCY } from './constants';

/**
 * Quick access to default currency code.
 */
export { DEFAULT_CURRENCY };

/**
 * Currencies configuration.
 */
export const currencies = {
  EUR: '€',
  GBP: '£',
  USD: '$',
};

export const currencySymbolPath = {
  GBP: <PoundIcon />,
  EUR: <EuroIcon />,
  USD: <DollarIcon />,
};

/**
 * Returns currency symbol by code.
 */
export const getSymbol = (currencyCode) => currencies[currencyCode];

/**
 * Returns formatted amount string.
 */
export const formatAmount = (currencyCode, amount, keepTwoNumbersAfterDecimalPoint) => {
  const numberAmount = Number(amount);
  return `${getSymbol(currencyCode)}${Number.isInteger(numberAmount) && !keepTwoNumbersAfterDecimalPoint ? numberAmount.toLocaleString() : numberAmount.toFixed(2).toLocaleString()}`;
};
